import React, { useState } from "react"
import { Link } from "react-router-dom"
import AuthLayout from "../components/AuthLayout"
import { getAPIBaseURL } from "../services/helpers"
import { postData } from "../services/request"
import { getApiErrorMessage } from "../services/apiErrorMessage"
import { validateEmail } from "../services/validators"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [btnState, setBtnState] = useState("Send reset link")
  const [error, setError] = useState([{ field: "email", msg: "" }])
  const [genMsg, setGenMsg] = useState("")
  const [genError, setGenError] = useState("")

  const submit = async () => {
    setGenMsg("")
    setGenError("")
    const eVal = validateEmail(email)
    setError([{ field: "email", msg: eVal.result }])
    if (eVal.error != "") return
    setBtnState("Sending...")
    const url = `${getAPIBaseURL()}/v1/users/forgot-password`
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const params = new URLSearchParams()
    params.append('email', email)
    const res = await postData(url, headers, params.toString())
    setBtnState("Send reset link")
    if (res.error == ""){
      if(res.result.status === 200){
        setGenMsg('Check your email for a link to reset your password.')
      }else{
        setGenError(getApiErrorMessage(res, 'Could not start password reset'))
      }
    }else{
      setGenError(getApiErrorMessage(res, 'Could not reach the server'))
    }
  }

  return (
    <AuthLayout title="Forgot password" subtitle="Enter your email to receive a password reset link.">
      <div className="space-y-5">
        {genMsg ? <div className="rounded-lg bg-green-50 p-3 text-sm font-semibold text-green-600">{genMsg}</div> : null}
        {genError ? <div className="rounded-lg bg-red-50 p-3 text-sm font-semibold text-red-500">{genError}</div> : null}
        <div>
          <label htmlFor="email" className="mb-2 block text-sm font-medium text-gray-900">Email</label>
          <input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" id="email" className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-600 focus:ring-primary-600" placeholder="name@example.com" />
          {error[0].msg ? <p className="mt-1 text-sm font-semibold text-red-500">{error[0].msg}</p> : null}
        </div>
        <button onClick={()=>submit()} type="button" className="w-full rounded-lg bg-black px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300">{btnState}</button>
        <p className="text-sm font-light text-gray-500"><Link to="/login" className="font-medium text-blue-600 hover:underline">Back to login</Link></p>
      </div>
    </AuthLayout>
  )
}

export default ForgotPassword


